export enum AccessControlRole {
  Admin = 'Admin',
  Disponent = 'Disponent',
  Inspector = 'Inspector',
  KFM = 'KFM',
}
